<div class="container">
    <h1>
        Welcome, <em>{{ firstName }}</em
        >!
    </h1>
    <h5>If you need help, please email contact&#64;playoctopus.com. Thank you!</h5>
    <br />
</div>
